const u = (t) => Array.isArray(t) ? t : t.split(" ").length === 1 ? [t, t, t, t] : t.split(" "), x = (t) => {
  if (!t)
    return "";
  const e = u(t), o = e.length;
  if (o === 2) {
    const [n, r] = e;
    return [`mt-${n}`, `mr-${r}`, `mb-${n}`, `ml-${r}`].join(" ");
  }
  if (o === 3) {
    const [n, r, s] = e;
    return [`mt-${n}`, `mr-${r}`, `mb-${s}`, `ml-${r}`].join(" ");
  }
  const [m, i, $, l] = e;
  return [`mt-${m}`, `mr-${i}`, `mb-${$}`, `ml-${l}`].join(" ");
};
export {
  x as n
};
